import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[appMinTwoWords], [appMinTwoWords][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MinTwoWordsDirective),
      multi: true
    }
  ]
})

export class MinTwoWordsDirective implements Validator {
  @Input() appMinTwoWords: any;

  constructor() { }

  validate(c: AbstractControl): { [key: string]: any } {
    if (
      !this.appMinTwoWords &&
      this.appMinTwoWords !== null &&
      this.appMinTwoWords !== undefined &&
      this.appMinTwoWords !== ''
    ) {
      return null;
    }

    if (c.value) {
      if (c.value.trim().split(' ').length > 1 && c.value.trim().split(' ').every(string => string.length > 0)) {
        return null;
      }
    }

    return { message: 'O nome deve conter no mínimo duas palavras' };
  }
}
